const timeout = require('infinite-timeout');
const localforage = require('localforage');
const memoryDriver = require('localforage-driver-memory');

const versionKey = '$$version';

let storage = null;
let memory = null;

(async () => {
	storage = localforage.createInstance({
		name: 'da-graphql-client',
	});

	// can't seem to get this to work for unit testing so leave as null
	// and do no caching for memory driver during unit testing
	if (memoryDriver._driver) {
		localforage.defineDriver(memoryDriver);
		memory = localforage.createInstance({
			driver: memoryDriver._driver,
			name: 'memory',
		});
	}
})();

const getInstance = type => {
	return type === dataCache.CacheType.Memory ? memory : storage;
};

const dataCache = {
	CacheType: {
		Memory: 1,
		Storage: 2,
	},
	clear: async (type) => {
		return await getInstance(type).clear();
	},
	getItem: async (type, key) => {
		if (key == null) {
			throw new Error('Required argument key is undefined');
		}

		const instance = getInstance(type);
		if (!instance) {
			return Promise.resolve(null);
		}

		const record = await instance.getItem(key);
		if (!record) {
			return Promise.resolve(null);
		}

		// stored as a string date in unit tests
		let expirationDate = record.expirationDate;
		if (expirationDate && typeof record.expirationDate === 'string') {
			expirationDate = new Date(record.expirationDate);
		}

		// if we have already expired, we should manually delete.
		// this can happen if application has been closed in between.
		if (expirationDate && expirationDate.getTime() <= Date.now()) {
			dataCache.removeItem(type, key);
			return Promise.resolve(null);
		}

		return Promise.resolve(record.value);
	},
	removeItem: (type, key) => {
		const instance = getInstance(type);
		if (!instance) {
			return;
		}

		getInstance(type).removeItem(key);
	},
	setItem: async (type, key, value, ttl) => {
		if (key == null) {
			throw new Error('Required argument key is undefined');
		}

		const instance = getInstance(type);
		if (!instance) {
			return Promise.resolve();
		}

		// Clear timeout on existing record
		const oldRecord = await instance.getItem(key);
		if (oldRecord && oldRecord.timeout) {
			timeout.clear(oldRecord.timeout);
		}

		// Set value + timeout on new record
		const record = {
			expirationDate: ttl ? new Date(Date.now() + (ttl)) : null,
			timeout: ttl ? timeout.set(() => dataCache.removeItem(type, key), ttl) : null,
			value
		};
		await instance.setItem(key, record);

		return Promise.resolve();
	},
};

module.exports = dataCache;